import React, { useState } from "react";

function Testing() {
  
  const [imagePreviews, setImagePreviews] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Create preview URLs for the selected files
    const previews = files.map((file) => URL.createObjectURL(file));

    setImagePreviews(previews);
    setImageFiles(files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Append each image file to FormData
    imageFiles.forEach((file, index) => {
      formData.append(`images[${index}]`, file);
    });
  };

  return (
    <>
      <div className="upload-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="image-upload">Upload Images:</label>
            <input
              type="file"
              id="image-upload"
              accept="image/*"
              multiple
              onChange={handleImageChange}
            />
          </div>
          <div className="image-previews">
            {imagePreviews.map((preview, index) => (
              <img
                key={index}
                src={preview}
                alt={`Preview ${index}`}
                width="100"
                height="100"
                style={{ margin: "5px" }}
              />
            ))}
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </>
  );
}

export default Testing;
